export const consts = {
  dr_name: 'ד"ר שי תלם',
  dr_title: "בעל תואר ברפואת שיניים, בוגר ומרצה באוניברסיטת תל אביב.",
  dr_description:
    'ד"ר שי תלם מאמין בגישה אישית המותאמת לכל מטופל ומטופלת, באיכות בלתי מתפשרת וביושרה מקצועית ללא פשרות. בעבודתו, הוא משלב חדשנות עם אהבה לעשייה מוקפדת ויצירתית, תוך שימוש בטכניקות מתקדמות ובחומרים האיכותיים ביותר. מעל לכל, ד"ר תלם דוגל בדיאלוג בגובה העיניים ובשאיפה להעניק לכל מטופל את התוצאה המושלמת עבורו.',
  testimonials: [
    {
      id: 1,
      text: "דר' תלם נתן לי חוות דעת מקצועית טובה ואמינה, כשהגעתי אליו, הרגשתי שיש על מי לסמוך! דר' תלם טיפל בי במקצועיות ונתן המלצות טובות ותוצאות הטיפול הושגו בהצלחה. ומעבר לכך פגשתי אדם נעים ורגוע והרגשתי בטוחה לקבל טיפול בנושא רגיש.",
      name: "oshrit s.",
    },
    {
      id: 2,
      text: 'ד"ר תלם הוא הרופא הראשון שהביא אותי לתוצאות שבאמת רציתי מבחינת אסתטיקה. מומחה אמיתי בתחומו ומסביר על התהליך בסבלנות ובאכפתיות. הרופא הראשון שההזרקות אצלו העניקו לי מראה טבעי ולא עשוי מדי וזו הסיבה שממשיך לחזור אליו כל פעם מחדש.',
      name: "שי ג.",
    },
    {
      id: 3,
      text: "מעבר להיותו אחד הרופאים היותר נעימים שפגשתי, מדובר אדם מקצועי ביותר, מרגיע,קשוב ,אמין שיודע בדיוק מה צריך ולא סתם דוחף טיפולים. נתן לי פוש אדיר לביטחון העצמי. מומלץ בחום רב!",
      name: "שקד מ.",
    },
    {
      id: 4,
      text: "ד״ר שי תלם הוא רופא מקצועי ואדם אכפתי עם ידי זהב, אכפת לו מהמטופלים שלו והוא שואף שכולם יצאו מרוצים מהטיפול הוא עובד בשיטות הכי חדישות ובאמת שכלום לא כואב! מומלץ בחום!!",
      name: "Apple User",
    },
    {
      id: 5,
      text: "ד״ר שי תלם אין אלוף כזה נהננו מעבודה מדהימה רופא אמין מקצוען חדשני ופורץ דרך בתחומו מביא את השיטות הטובות והעדכניות בעולם במחירים ללא תחרות . תודה רבה מכל הלב💙",
      name: "Erez B.",
    },
    {
      id: 6,
      text: "עשיתי אצל ד״ר תלם שפתיים ועוד מס טיפולים. המחאות לא הפסיקו להגיע. דר' תלם רופא מדויק ומקצועי שיודע להגיע לתוצאות הכי טבעיות שיש",
      name: "קורין ב.",
    },
    {
      id: 7,
      text: "ד׳ר תלם הוא רופא מדהים, קשוב, מרגיע ונותן את כל המענה המתבקש ומעבר לכך. תוצאה עדינה ומדוייקת ! ממליצה בחום!",
      name: "Sharon K.",
    },
    {
      id: 8,
      text: "אני אצל ד״ר שי כבר תקופה ארוכה, אני ממש ממליץ. מאוד מקצועי וסטרילי, אדיב ואינפורמטיבי!!",
      name: "Rotem o.",
    },
    {
      id: 9,
      text: "רופא מעולה טיפולים מעולים ומוצלחים טיפל לי את הבעיות שרופאים אחרים עשו לי",
      name: "אלברט א.",
    },
    {
      id: 10,
      text: "ד״ר שי אלוף אמיתי! יש לו ידי זהב ❤️❤️❤️",
      name: "Hofit G.",
    },
  ],
};
